import React, { useState, Suspense, lazy } from 'react';

// Lazy load each tab's content
const Homealltab = lazy(() => import('../components/Homealltab'));
const Homefollowingtab = lazy(() => import('../components/Homefollowingtab'));
const Hometrendingtab = lazy(() => import('../components/Hometrendingtab'));
const Homefreebiestab = lazy(() => import('../components/Homefreebiestab'));
const Homepurchasedtab = lazy(() => import('../components/Homepurchasedtab'));

const HomePills = () => {
  const [activeTab, setActiveTab] = useState('all'); // Track active tab

  const handleTabChange = (tab) => {
    setActiveTab(tab); // Change the active tab
  };

  return (
    <div className="category_pills">
      <div className="pill_tabs">
        <ul className="nav nav-pills" id="pills-tab" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${activeTab === 'all' ? 'active' : ''}`}
              onClick={() => handleTabChange('all')}
              id="pills-all-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-all"
              type="button"
              role="tab"
              aria-controls="pills-all"
              aria-selected={activeTab === 'all'}
            >
              All
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${activeTab === 'following' ? 'active' : ''}`}
              onClick={() => handleTabChange('following')}
              id="pills-following-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-following"
              type="button"
              role="tab"
              aria-controls="pills-following"
              aria-selected={activeTab === 'following'}
            >
              Following
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${activeTab === 'trending' ? 'active' : ''}`}
              onClick={() => handleTabChange('trending')}
              id="pills-trending-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-trending"
              type="button"
              role="tab"
              aria-controls="pills-trending"
              aria-selected={activeTab === 'trending'}
            >
              Trending
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${activeTab === 'freebies' ? 'active' : ''}`}
              onClick={() => handleTabChange('freebies')}
              id="pills-freebies-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-freebies"
              type="button"
              role="tab"
              aria-controls="pills-freebies"
              aria-selected={activeTab === 'freebies'}
            >
              Nuggets
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${activeTab === 'purchased' ? 'active' : ''}`}
              onClick={() => handleTabChange('purchased')}
              id="pills-purchased-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-purchased"
              type="button"
              role="tab"
              aria-controls="pills-purchased"
              aria-selected={activeTab === 'purchased'}
            >
              Purchased
            </button>
          </li>
        </ul>
      </div>

      <div className="tab-content" id="pills-tabContent">
        {/* Use Suspense to lazily load each tab's content without fallback */}
        <div
          className={`tab-pane fade ${activeTab === 'all' ? 'show active' : ''}`}
          id="pills-all"
          role="tabpanel"
          aria-labelledby="pills-all-tab"
        >
          <Suspense fallback={null}>
            {activeTab === 'all' && <Homealltab />}
          </Suspense>
        </div>
        <div
          className={`tab-pane fade ${activeTab === 'following' ? 'show active' : ''}`}
          id="pills-following"
          role="tabpanel"
          aria-labelledby="pills-following-tab"
        >
          <Suspense fallback={null}>
            {activeTab === 'following' && <Homefollowingtab />}
          </Suspense>
        </div>
        <div
          className={`tab-pane fade ${activeTab === 'trending' ? 'show active' : ''}`}
          id="pills-trending"
          role="tabpanel"
          aria-labelledby="pills-trending-tab"
        >
          <Suspense fallback={null}>
            {activeTab === 'trending' && <Hometrendingtab />}
          </Suspense>
        </div>
        <div
          className={`tab-pane fade ${activeTab === 'freebies' ? 'show active' : ''}`}
          id="pills-freebies"
          role="tabpanel"
          aria-labelledby="pills-freebies-tab"
        >
          <Suspense fallback={null}>
            {activeTab === 'freebies' && <Homefreebiestab />}
          </Suspense>
        </div>
        <div
          className={`tab-pane fade ${activeTab === 'purchased' ? 'show active' : ''}`}
          id="pills-purchased"
          role="tabpanel"
          aria-labelledby="pills-purchased-tab"
        >
          <Suspense fallback={null}>
            {activeTab === 'purchased' && <Homepurchasedtab />}
          </Suspense>
        </div>
      </div>
    </div>
  );
};

export default HomePills;
